import { useTranslation } from 'react-i18next'
import { Button, Caption, H3, Text } from '@/components/atoms'
import { TELEVET_PHONE } from '@/shared/constants/env'
import { useTelevetPage } from './page.televet.hook'
import televetPlaceholder from '@/shared/assets/icons/AirvetDog.svg'
import { useHideHeader } from '@/shared/hooks/use-hide-header'

export function TelevetPage() {
  const { t } = useTranslation()
  const hideHeader = useHideHeader()
  const {
    televetUrl,
    chatButtonLoading,
    showTelevetIframe,
    openTelevetIframe,
    closeTelevetIframe,
  } = useTelevetPage()

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col items-center justify-center px-6 py-10 text-center">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-3">
          <H3 className="font-bold text-indigo-900">{t('televet.title')}</H3>
          <Text className="text-neutral-600">{t('televet.subtitle')}</Text>
        </div>

        <img
          src={televetPlaceholder}
          alt=""
          aria-hidden
          className="h-44 w-44 opacity-60"
        />

        <div className="flex flex-col gap-4">
          <Text className="text-neutral-700">{t('televet.body1')}</Text>
          <Caption className="text-neutral-400">
            {t('televet.footnote')}
          </Caption>
        </div>

        <div className="flex w-full gap-3">
          <Button
            as="a"
            variant="secondary"
            fullWidth
            href={`tel:${TELEVET_PHONE}`}
          >
            {t('televet.callBtn')}
          </Button>
          <Button
            variant="primary"
            fullWidth
            loading={chatButtonLoading}
            onClick={openTelevetIframe}
          >
            {t('televet.chatBtn')}
          </Button>
        </div>
      </div>

      {showTelevetIframe && televetUrl && (
        <div
          className={`fixed inset-x-0 bottom-0 z-50 flex flex-col bg-white ${hideHeader ? 'top-0' : 'top-[var(--header-h)]'}`}
        >
          <div className="flex items-center justify-between border-b border-neutral-200 px-4 py-3">
            <span className="font-semibold text-indigo-900">
              {t('televet.iframeTitle')}
            </span>
            <Button variant="link" onClick={closeTelevetIframe}>
              {t('televet.close')}
            </Button>
          </div>
          <iframe
            src={televetUrl}
            title={t('televet.iframeTitle')}
            className="w-full flex-1 border-none"
            allow="camera; microphone"
          />
        </div>
      )}
    </div>
  )
}
